module.exports = __webpack_public_path__ + "static/media/Facebook_Guide_Chin_Computer.a15080a8.docx";